import { render, staticRenderFns } from "./Categories.list.vue?vue&type=template&id=281fa754&"
import script from "./Categories.list.vue?vue&type=script&lang=js&"
export * from "./Categories.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports